    <!-- Wird benötigt für arlTableHeader -->
<!--    <div cdkDropList [cdkDropListData]="addButtons" id="arlTableDrag" class="add-button-list">-->
<!--        <button-->
<!--            cdkDrag-->
<!--            mat-button-->
<!--            cdkDragPreviewContainer="parent"-->
<!--            class="grab-button"-->
<!--            [class.is-loading]="ls.IsLoading$ | async"-->
<!--            cdkDragPreviewClass="grabbing"-->
<!--            (cdkDragStarted)="onCdkDragStarted($event)"-->
<!--            (cdkDragEnded)="onCdkDragEnded($event)"-->
<!--            [cdkDragData]="b.type"-->
<!--            (click)="onClick(b.type)"-->
<!--            *ngFor="let b of addButtons"-->
<!--            [disabled]="_disabled"-->
<!--        >-->
<!--            <span>-->
<!--                <fa-icon icon="bars" style="margin-right: 0.5rem"></fa-icon>-->
<!--                <span>{{ b.label }}</span>-->
<!--            </span>-->
<!--        </button>-->
<!--        <span class="spacer"></span>-->
<!--        <button mat-icon-button (click)="enableDragNDrop()" *ngIf="!(bs.MobileQuery | async) && _disabled" matTooltip="Bearbeitung aktivieren"><fa-icon [icon]="'lock-open'"></fa-icon>&nbsp;<app-hint-icon hint="Bearbeitung deaktiviert da die Positionen von eine GAEB-DAtei importiert/exportiert wurden."></app-hint-icon></button>-->
<!--        <button mat-icon-button (click)="drawer.toggle()" *ngIf="!(bs.MobileQuery | async)" matTooltip="Tabelle anpassen"><fa-icon [icon]="drawer.opened ? 'times' : 'cog'"></fa-icon></button>-->
<!--    </div>-->
    <!--    <p>{{(tableData$ | async)?.length}}</p>-->
<!--    <mat-drawer-container class="drawer-container">-->
<!--        <mat-drawer mode="over" position="end" #drawer (closed)="submitColumnChange(config.selectedColumns)">-->
<!--            <app-table-config-form #config [columns]="columnConfig$ | async" [selectedColumns]="displayedColumns$ | async"></app-table-config-form>-->
<!--        </mat-drawer>-->
<!--        <mat-drawer-content>-->
<!--        </mat-drawer-content>-->
<!--    </mat-drawer-container>-->
{{logRender()}}

    <mat-table
        class="small-header-table"
        [cdkDropListSortPredicate]="canDropAtPosition"
        [cdkDropListConnectedTo]="[newArlBtnDragList]"
        [cdkDropListData]="paginatedData$ | async"
        cdkDropList
        [cdkDropListDisabled]="_disabled || (ls.IsLoading$ | async) || !!(searchQuery$ | async)"
        (cdkDropListDropped)="OnListDrop($event)"
        [dataSource]="paginatedData$"
        #bookingPositionTable
        multiTemplateDataRows
        #tableDragList="cdkDropList"
        [cdkDropListAutoScrollStep]="invoiceEditorAutoScrollSpeed"
    >
        <ng-container matColumnDef="QuantityType">
            <mat-header-cell *matHeaderCellDef class="{{ AutoColumnWithClass.QuantityType }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'QuantityType')">
                {{ AutoColumnHeaders['QuantityType'] }}
            </mat-header-cell>
            <mat-cell *matCellDef="let rowData" class="{{ AutoColumnWithClass.QuantityType }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'QuantityType')">
                <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData) && (rowData.isBookingPosition$ | async)">
                    <mat-form-field *ngIf="rowData.isExpanded$ | async; else value">
                        <mat-select (ngModelChange)="onQuantityTypeChange(rowData, $event)" [placeholder]="AutoColumnHeaders['QuantityType']" [ngModel]="rowData.form.controls.QuantityTypeId.value" [disabled]="!!forceQuantityTypeIdForEmployeeArls && rowData.form.value.Type === ARLTypeEnum.EmployeeArl">
                            <mat-option *ngFor="let t of arlCalculationDataService.quantityTypes$ | async" [value]="t.Id">{{ t.Name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <ng-template #value>
<!--                        {{ (getQuantityType$ | async)(rowData) }}-->
                        {{ rowData.selectedQuantityTypeName$ | async}}
                    </ng-template>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="BaseCost_salary">
            <mat-header-cell *matHeaderCellDef class="{{ AutoColumnWithClass.BaseCost_salary }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost_salary')">
                {{AutoColumnHeaders.BaseCost_salary}}
            </mat-header-cell>
            <mat-cell *matCellDef="let rowData" class="{{ AutoColumnWithClass.BaseCost }} flex-wrap cross-except-last-price" [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost_salary')">
                <ng-container *ngIf="rowData.isBookingPosition$ | async">
                    <ng-container *ngIf="rowData.isExpanded$ && rowData.isExpanded$ | async; else value">
                        <ng-container *ngIf="!rowData.form.value.InheritFromChildren; else value">
                            <mat-form-field>
                                <mat-label>Lohn</mat-label>
                                <app-number-transform-input [factor]="1" [formControl]="rowData.form.controls.SalaryBaseCost"
                                (ngModelChange)="
                                                            syncCostAmountAndBaseCost
                                                            ? syncOrderCosts(rowData, $event, 'changeFromLohn') :
                                onLohnChange($event, rowData)"></app-number-transform-input>
                                <mat-error></mat-error>
                                <mat-error class="form-field-error" *ngIf="rowData.form.controls.SalaryBaseCost.invalid">
                                    {{ getErrorMessage(rowData.form.controls.SalaryBaseCost) }}
                                </mat-error>
                            </mat-form-field>
                        </ng-container>
                    </ng-container>
                    <ng-template #value>
                        <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData)">
                            <span class="price">{{ rowData.form.value.SalaryBaseCost | currency: rowData.entity.CurrencyCode }}</span>
                                <ng-container *ngIf="rowData.baseCostsWithAllowanceCharges$ | async as baseCostData">
                                <!--                                    <ng-container *ngIf="baseCostData.salaryBaseCostWithArlCharges as v">{{ v | currency: rowData.entity.CurrencyCode }}</ng-container>-->
                                <ng-container *ngIf="isNotNullOrUndefined(baseCostData.salaryBaseCostWithArlAllowanceCharges) && baseCostData.salaryBaseCostWithArlAllowanceCharges !== rowData.form.value.SalaryBaseCost">
                                    <br>
                                    <span class="price">{{ baseCostData.salaryBaseCostWithArlAllowanceCharges | currency: rowData.entity.CurrencyCode }}</span>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-template>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="BaseCost_salary_cost">
            <mat-header-cell
                style="white-space: normal"
                *matHeaderCellDef
                class="{{ AutoColumnWithClass.BaseCost_salary_cost }}"
                [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost_salary_cost')">
                {{AutoColumnHeaders.BaseCost_salary_cost}}
            </mat-header-cell>
            <mat-cell
                *matCellDef="let rowData"
                class="{{ AutoColumnWithClass.BaseCost_salary_cost }}"
                [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost_salary_cost')">
                <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData) && (rowData.isBookingPosition$ | async)">
                    <ng-container *ngIf="rowData.baseCostsWithAllowanceCharges$ | async as baseCostData">
                        <!--                                    <ng-container *ngIf="baseCostData.salaryBaseCostWithArlCharges as v">{{ v | currency: rowData.entity.CurrencyCode }}</ng-container>-->
                        <ng-container *ngIf="rowData.form.value.InheritFromChildren">
                            <span>{{ rowData.employeeCostSum$ | async | currency: rowData.entity.CurrencyCode }}
                                <br>
                                {{ (rowData.percentDiff$ | async)?.employee ?? 0  | number: '1.2-2'  }}%</span>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="BaseCost_other_cost">
            <mat-header-cell
                style="white-space: normal"
                *matHeaderCellDef
                class="{{ AutoColumnWithClass.BaseCost_other_cost }}"
                [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost_other_cost')">
                {{AutoColumnHeaders.BaseCost_other_cost}}
            </mat-header-cell>
            <mat-cell
                *matCellDef="let rowData"
                class="{{ AutoColumnWithClass.BaseCost_other_cost }}"
                [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost_other_cost')">
                <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData) && (rowData.isBookingPosition$ | async)">
                    <ng-container *ngIf="rowData.baseCostsWithAllowanceCharges$ | async as baseCostData">
                        <span style="padding-left: 1rem">
                            {{ rowData.otherCostSum$ | async | currency: rowData.entity.CurrencyCode }}
                            <br>
                            {{ (rowData.percentDiff$ | async)?.other ?? 0 | number: '1.2-2' }}%
                        </span>
                    </ng-container>

                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="BaseCost_cost">
            <mat-header-cell style="white-space: normal" *matHeaderCellDef class="{{ AutoColumnWithClass.BaseCost_cost }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost_cost')">
                {{AutoColumnHeaders.BaseCost_cost}}
            </mat-header-cell>
            <mat-cell *matCellDef="let rowData" class="{{ AutoColumnWithClass.BaseCost_cost }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost_cost')">
                <ng-container *ngIf="rowData.isBookingPosition$ | async">
                    <!--                                    <ng-container *ngIf="baseCostData.salaryBaseCostWithArlCharges as v">{{ v | currency: rowData.entity.CurrencyCode }}</ng-container>-->
                    <span>{{ rowData.baseCostCostSum$ | async | currency: rowData.entity.CurrencyCode }}
                        <br>
                          {{ (rowData.percentDiff$ | async)?.baseCost ?? 0  | number: '1.2-2' }}%</span>
                    <!--                                CostAmount ist 0 bei Kalkulierten-->
                </ng-container>
                <ng-container *ngIf="!determineIfIsArlTableDataOrGroupEnd(rowData)">
                    <span *ngIf="rowData.costAmountVM$ | async as vm">{{ vm.costAmount  | currency: rowData.CurrencyCode  }}
                         <br>
                         {{ (vm.zs * 100) |  number: '1.2-2' }}%</span>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="BaseCostGross_cost">
            <mat-header-cell style="white-space: normal" *matHeaderCellDef class="{{ AutoColumnWithClass.BaseCostGross_cost }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCostGross_cost')">
                {{AutoColumnHeaders.BaseCostGross_cost}}
            </mat-header-cell>
            <mat-cell *matCellDef="let rowData" class="{{ AutoColumnWithClass.BaseCostGross_cost }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCostGross_cost')">
                <ng-container *ngIf="rowData.isBookingPosition$ | async">
                    <!--                                    <ng-container *ngIf="baseCostData.salaryBaseCostWithArlCharges as v">{{ v | currency: rowData.entity.CurrencyCode }}</ng-container>-->
                    <span>{{ rowData.baseCostGrossCostSum$ | async | currency: rowData.entity.CurrencyCode }}
                        <br>
                        {{ (rowData.percentDiff$ | async)?.baseCost ?? 0  | number: '1.2-2' }}%</span>
                    <!--                                CostAmount ist 0 bei Kalkulierten-->
                </ng-container>
                <ng-container *ngIf="!determineIfIsArlTableDataOrGroupEnd(rowData)">
                    <span *ngIf="rowData.costAmountVM$ | async as vm">{{ vm.costAmountGross | currency: rowData.CurrencyCode  }}
                        <br>
                        {{ (vm.zs * 100) |  number: '1.2-2' }}%</span>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="BaseCost_other">
            <mat-header-cell *matHeaderCellDef class="{{ AutoColumnWithClass.BaseCost_other }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost_other')">
                {{AutoColumnHeaders.BaseCost_other}}
            </mat-header-cell>
            <mat-cell *matCellDef="let rowData" class="{{ AutoColumnWithClass.BaseCost }} flex-wrap cross-except-last-price" [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost_other')">
                <ng-container *ngIf="rowData.isBookingPosition$ | async">
                    <ng-container *ngIf="rowData.isExpanded$ && rowData.isExpanded$ | async; else value">
                        <ng-container *ngIf="!rowData.form.value.InheritFromChildren; else value">
                            <mat-form-field>
                                <mat-label>Sonstiges</mat-label>
                                    <app-number-transform-input [factor]="1" [formControl]="rowData.form.controls.sonstigesBaseCost"
                                        (ngModelChange)="
      syncCostAmountAndBaseCost
        ? syncOrderCosts(rowData, $event, 'changeFromSonstiges')
       : onSonstigeChange($event, rowData)
    "></app-number-transform-input>
                                <mat-error class="form-field-error" *ngIf="rowData.form.controls.sonstigesBaseCost.invalid">
                                    {{ getErrorMessage(rowData.form.controls.sonstigesBaseCost) }}
                                </mat-error>
                            </mat-form-field>
                        </ng-container>
                    </ng-container>
                    <ng-template #value>
                        <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData)">
                            <span class="price">{{ rowData.form.value.BaseCost - rowData.form.value.SalaryBaseCost | currency: rowData.entity.CurrencyCode }}</span>

                                <ng-container *ngIf="rowData.baseCostsWithAllowanceCharges$ | async as baseCostData">
                                <!--                                    <ng-container *ngIf="baseCostData.salaryBaseCostWithArlCharges as v">{{ v | currency: rowData.entity.CurrencyCode }}</ng-container>-->
                                <ng-container *ngIf="isNotNullOrUndefined(baseCostData.otherBaseCostWithArlAllowanceCharges) && baseCostData.otherBaseCostWithArlAllowanceCharges !== (rowData.form.value.BaseCost - rowData.form.value.SalaryBaseCost)">
                                    <br>
                                    <span class="price">{{ baseCostData.otherBaseCostWithArlAllowanceCharges | currency: rowData.entity.CurrencyCode }}</span>
                                </ng-container>
                            </ng-container>

                        </ng-container>
                    </ng-template>
                </ng-container>
            </mat-cell>

        </ng-container>
        <ng-container matColumnDef="BaseCost">
            <mat-header-cell *matHeaderCellDef class="{{ AutoColumnWithClass.BaseCost }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost')">
                {{ AutoColumnHeaders.BaseCost }}
            </mat-header-cell>
            <mat-cell *matCellDef="let rowData" class="{{ AutoColumnWithClass.BaseCost }} flex-wrap " [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCost')">
                <app-arl-table-cell-base-cost
                    [rowData]="rowData"
                    [useArlSeparateSalaryBaseCost]="useArlSeparateSalaryBaseCost$ | async"
                    [baseCostLabel]="AutoColumnHeaders.BaseCost"
                    [disabledSurchargeInput]="_disabled"
                    (baseCostChange)="syncCostAmountAndBaseCost
                        ? syncOrderCosts(rowData, $event, 'changeFromBaseCost')
                        : baseCostChange(rowData)"
                    (costAmountChange)="syncCostAmountAndBaseCost
                        ? syncOrderCosts(rowData, $event, 'changeFromCostAmount')
                        : costChange(rowData)"
                    (surchargePercentChange)="surchargePercentChange(rowData, $event)"
                    (costAmountBlur)="costBlur(rowData)"
                    (priceInformationClick)="onPriceInformationClick(rowData)"
                    (bidderClick)="onBidderClick(rowData)"
                ></app-arl-table-cell-base-cost>
<!--                <ng-container *ngIf="rowData.entity?.isBookingPosition">-->
<!--                    <ng-container *ngIf="rowData.isExpanded$ && rowData.isExpanded$ | async; else value">-->
<!--                        <ng-container *ngIf="!rowData.form.value.InheritFromChildren; else value">-->
<!--                            <div class="flex gap-2">-->
<!--                                <mat-form-field *ngIf="!(useArlSeparateSalaryBaseCost$ | async); else value">-->
<!--                                    <mat-label>{{ AutoColumnHeaders.BaseCost }}</mat-label>-->
<!--                                    <app-number-transform-input [factor]="1" [formControl]="rowData.form.controls.BaseCost"  (ngModelChange)="-->
<!--                                          syncCostAmountAndBaseCost-->
<!--                                            ? syncOrderCosts(rowData, $event, 'changeFromBaseCost')-->
<!--                                            :baseCostChange(rowData)"></app-number-transform-input>-->
<!--                                    <mat-error class="form-field-error" *ngIf="rowData.form.controls.BaseCost.invalid">-->
<!--                                        {{ getErrorMessage(rowData.form.controls.BaseCost) }}-->
<!--                                    </mat-error>-->
<!--                                </mat-form-field>-->
<!--                                &lt;!&ndash;                                    <div>&ndash;&gt;-->
<!--                                &lt;!&ndash;                                        {{rowData.baseCostWithArlAllowances$ | async | currency: rowData.entity.CurrencyCode}}&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--                            </div>-->

<!--                            <div class="flex flex-col mt-2">-->
<!--                                <mat-form-field>-->
<!--                                    <mat-label>Kosten</mat-label>-->
<!--                                        <app-number-transform-input-->
<!--                                            [formControl]="rowData.form.controls.CostAmount"-->
<!--                                            (blur)="costBlur(rowData)"-->
<!--                                            (ngModelChange)="-->
<!--                                              syncCostAmountAndBaseCost-->
<!--                                                ? syncOrderCosts(rowData, $event, 'changeFromCostAmount')-->
<!--                                                : costChange(rowData)-->
<!--                                            "-->
<!--                                        ></app-number-transform-input>-->
<!--                                    <mat-error class="form-field-error" *ngIf="rowData.form.controls.CostAmount.invalid">-->
<!--                                        {{ getErrorMessage(rowData.form.controls.CostAmount) }}-->
<!--                                    </mat-error>-->
<!--                                </mat-form-field>-->
<!--                                <mat-form-field>-->
<!--                                    <mat-label>Zuschlag</mat-label>-->
<!--                                    <app-hint-icon-->
<!--                                        *ngIf="isNotNullOrUndefined(rowData.form.controls.SurchargeOverride.getRawValue())"-->
<!--                                        hint="Zuschlag wurde an einem Titel überschrieben. Vorbewertungen und Erhöhung / Minderung werden nicht berücksichtigt bis der Zuschlag entfernt wird"-->
<!--                                        matPrefix class="mr-2"-->
<!--                                    ></app-hint-icon>-->
<!--                                    <ng-container *ngIf="LiDocumentType$ | async as docType">-->

<!--                                        <app-number-transform-input-->
<!--                                            [disabled]="_disabled"-->
<!--                                            [ngModel]="isNotNullOrUndefined(rowData.form.controls.SurchargeOverride.getRawValue()) ? rowData.form.controls.SurchargeOverride.value : rowData.surchargePercentForm.value"-->
<!--                                            (ngModelChange)="surchargePercentChange(rowData, $event)"></app-number-transform-input>-->
<!--                                    </ng-container>-->
<!--                                    <span matSuffix>%</span>-->
<!--                                </mat-form-field>-->
<!--                            </div>-->
<!--                        </ng-container>-->
<!--                    </ng-container>-->

<!--                    <ng-template #value>-->
<!--                        <div class="cross-except-last-price" *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData)">-->
<!--                            <span class="price">{{ rowData.form.value.BaseCost | currency: rowData.entity.CurrencyCode }}</span>-->
<!--                                <ng-container *ngIf="rowData.baseCostsWithAllowanceCharges$ | async as baseCostData">-->
<!--                                &lt;!&ndash;                                    <ng-container *ngIf="baseCostData.salaryBaseCostWithArlCharges as v">{{ v | currency: rowData.entity.CurrencyCode }}</ng-container>&ndash;&gt;-->
<!--                                <ng-container *ngIf="isNotNullOrUndefined(baseCostData.baseCostWithArlAllowanceCharges) && baseCostData.baseCostWithArlAllowanceCharges !== rowData.form.value.BaseCost">-->
<!--                                    <br>-->
<!--                                    <span class="price">{{ baseCostData.baseCostWithArlAllowanceCharges | currency: rowData.entity.CurrencyCode }}</span>-->
<!--                                </ng-container>-->
<!--                            </ng-container>-->
<!--                        </div>-->
<!--                    </ng-template>-->

<!--                    <ng-container *ngIf="rowData.form?.controls.Type.value === ARLTypeEnum.MaterialArl">-->
<!--                        <button mat-icon-button matTooltip="Preisgestaltung" (click)="onPriceInformationClick(rowData)" [disabled]="!rowData.form.value.MaterialId">-->
<!--                            <fa-icon icon="info-circle"></fa-icon>-->
<!--                        </button>-->
<!--                    </ng-container>-->
<!--                    <ng-container *ngIf="rowData.form?.controls.PriceComparisonId.value">-->
<!--                        <button mat-icon-button matTooltip="Bieter" (click)="onBidderClick(rowData)" >-->
<!--                            <fa-icon icon="info-circle"></fa-icon>-->
<!--                        </button>-->
<!--                    </ng-container>-->
<!--                </ng-container>-->
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="BaseCostGross">
            <mat-header-cell *matHeaderCellDef class="{{ AutoColumnWithClass.BaseCostGross }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCostGross')">
                {{ AutoColumnHeaders.BaseCostGross }}
            </mat-header-cell>
            <mat-cell *matCellDef="let rowData" class="{{ AutoColumnWithClass.BaseCostGross }} flex-wrap " [class.hide]="!(DisplayedColumns$ | async | includes: 'BaseCostGross')">
                <ng-container *ngIf="rowData.isBookingPosition$ | async">
                    <ng-container *ngIf="rowData.isExpanded$ && rowData.isExpanded$ | async; else value">
                        <ng-container *ngIf="!rowData.form.value.InheritFromChildren; else value">
                            <div class="flex gap-2">
                                <mat-form-field *ngIf="!(useArlSeparateSalaryBaseCost$ | async); else value">
                                    <mat-label>{{ AutoColumnHeaders.BaseCostGross }}</mat-label>
                                        <app-number-transform-input [factor]="1" [formControl]="rowData.form.controls.BaseCostGross" (ngModelChange)="
                                             baseCostGrossChange(rowData)
                                            "></app-number-transform-input>
                                    <mat-error class="form-field-error" *ngIf="rowData.form.controls.BaseCostGross.invalid">
                                        {{ getErrorMessage(rowData.form.controls.BaseCostGross) }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-template #value>
                        <div class="cross-except-last-price" *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData)">
                            <span class="price">{{ rowData.form.value.BaseCostGross | currency: rowData.entity.CurrencyCode }}</span>

                            <ng-container *ngIf="rowData.baseCostsWithAllowanceCharges$ | async as baseCostData">
                                <!--                                    <ng-container *ngIf="baseCostData.salaryBaseCostWithArlCharges as v">{{ v | currency: rowData.entity.CurrencyCode }}</ng-container>-->
                                <ng-container *ngIf="isNotNullOrUndefined(baseCostData.baseCostGrossWithArlAllowanceCharges) && baseCostData.baseCostGrossWithArlAllowanceCharges !== rowData.form.value.BaseCostGross">
                                    <br>
                                    <span class="price">{{ baseCostData.baseCostGrossWithArlAllowanceCharges | currency: rowData.entity.CurrencyCode }}</span>
                                </ng-container>
                            </ng-container>
                        </div>
                    </ng-template>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="BookingText">
            <mat-header-cell *matHeaderCellDef class="{{ AutoColumnWithClass.BookingText }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'BookingText')">
                {{ AutoColumnHeaders.BookingText }}
            </mat-header-cell>
            <mat-cell *matCellDef="let rowData" class="{{ AutoColumnWithClass.BookingText }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'BookingText')">
                <ng-container *ngIf="rowData.isExpanded$ && rowData.isExpanded$ | async; else value">
<!--                    <ng-container  *ngIf="rowData.entity.isBookingPosition">-->
                        <mat-form-field  *ngIf="rowData.isBookingPosition$ | async">
                            <mat-label>{{ AutoColumnHeaders.BookingText }}</mat-label>
                            <input matInput [formControl]="rowData.form.controls.BookingText" />
                        </mat-form-field>
<!--                    </ng-container>-->
                </ng-container>
                <ng-template #value>
                    {{ dataAccessor(rowData, 'BookingText') }}
                </ng-template>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Quantity">
            <mat-header-cell *matHeaderCellDef class="{{ AutoColumnWithClass.Quantity }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'Quantity')">
                {{ AutoColumnHeaders.Quantity }}
            </mat-header-cell>
            <mat-cell *matCellDef="let rowData" class="{{ AutoColumnWithClass.Quantity }} flex-wrap" [class.hide]="!(DisplayedColumns$ | async | includes: 'Quantity')">
                <ng-container *ngIf="rowData.isExpanded$ && rowData.isExpanded$ | async; else value">
                    <ng-container *ngIf="rowData.isBookingPosition$ | async">
                        <div *ngIf="rowData.form.controls.UseQuantityHistory.value; else normalQuantityInput">
                            <div class="flex justify-between items-center">
                                <span>{{rowData.form.controls.Quantity.value}}</span>
                                <div>
                                    <button mat-icon-button (click)="editQuantityHistory(rowData)">
                                        <fa-icon icon="pencil"></fa-icon>
                                    </button>
                                    <button
                                        mat-icon-button
                                        (click)="rowData.form.controls.ShowQuantityHistory.markAsDirty(); rowData.form.controls.ShowQuantityHistory.setValue(!rowData.form.value.ShowQuantityHistory);"
                                        [matTooltip]="'Historie ' + (rowData.form.value.ShowQuantityHistory ? 'ausblenden' : 'einblenden')"
                                        [disabled]="rowData.form.controls.ShowQuantityHistory.disabled || _disabled"
                                    >
                                        <fa-icon [icon]="rowData.form.value.ShowQuantityHistory ? 'eye' : 'eye-slash'"></fa-icon>
                                    </button>
                                </div>
                            </div>
                            <form (submit)="$event.preventDefault(); onQuantityHistorySubmit(rowData);" class="flex items-center">
                                <mat-form-field>
                                    <mat-label></mat-label>
                                    <input type="number" matInput [formControl]="rowData.addQuantityHistoryForm" />
                                </mat-form-field>
                                <button mat-icon-button type="submit" [disabled]="!rowData.addQuantityHistoryForm.value">
                                    <fa-icon icon="plus"></fa-icon>
                                </button>
                            </form>
                        </div>
                        <ng-template #normalQuantityInput>
                            <mat-form-field>
                                <mat-label>{{ AutoColumnHeaders.Quantity }}</mat-label>
<!--                                <input type="number" matInput [formControl]="rowData.form.controls.Quantity" (ngModelChange)="quantityChange(rowData)"/>-->
                                <app-calculation-input
                                    [maxDecimalPlaces]="AccountsReceivableLedgerEntity.QuantityDecimalPlaces"
                                    [formula]="rowData.form.controls.QuantityFormula.value"
                                    (formulaChange)="rowData.form.controls.QuantityFormula.setValue($event); rowData.form.controls.QuantityFormula.markAsDirty()"
                                    [formulaUsedVariables]="rowData.form.controls.QuantityFormulaUsedVariables.value"
                                    (formulaUsedVariablesChange)="rowData.form.controls.QuantityFormulaUsedVariables.setValue($event); rowData.form.controls.QuantityFormulaUsedVariables.markAsDirty()"
                                    [useVariables]="true"
                                    [formControl]="rowData.form.controls.Quantity"
                                ></app-calculation-input>
                            </mat-form-field>
                        </ng-template>
                    </ng-container>
                </ng-container>
                <ng-template #value>
                    {{ dataAccessor(rowData, 'Quantity') }}
                </ng-template>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Information">
            <mat-header-cell *matHeaderCellDef class="{{ AutoColumnWithClass.Information }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'Information')">
                {{ AutoColumnHeaders.Information }}
            </mat-header-cell>
            <mat-cell *matCellDef="let rowData" class="{{ AutoColumnWithClass.Information }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'Information')">
                <app-arl-table-cell-information
                    class="w-full"
                    [rowData]="rowData"
                    [_disabled]="_disabled"
                    (setEntityId)="onSetEntityId(rowData, $event.id, $event.m2s)"
                >
                </app-arl-table-cell-information>
<!--                &lt;!&ndash;                <mat-form-field *ngIf="rowData.isExpanded$ && rowData.isExpanded$ | async; else value">&ndash;&gt;-->
<!--                &lt;!&ndash;                    <mat-label>{{ AutoColumnHeaders.Information }}</mat-label>&ndash;&gt;-->
<!--                &lt;!&ndash;                    <input matInput [formControl]="rowData.form?.controls.Information" />&ndash;&gt;-->
<!--                &lt;!&ndash;                </mat-form-field>&ndash;&gt;-->

<!--                <div class="theme-override {{ ResourcePageMeta.Theme }}" *ngIf="false && rowData.form?.value.ResourceId">-->
<!--                    <button mat-icon-button [disabled]="_disabled" color="primary" (click)="onSetEntityId(rowData, null)" [matTooltip]="(rowData.resource$ | async)?.DisplayName + ' entfernen'">-->
<!--                        <app-double-icon [Icon]="ResourcePageMeta.Icon" Icon2="link"></app-double-icon>-->
<!--                    </button>-->
<!--                </div>-->
<!--                <fa-icon icon="signs-post" *ngIf="rowData.form?.controls.IsOptional.getRawValue()" style="margin-right: 0.5rem" matTooltip="optional"></fa-icon>-->
<!--                <fa-icon icon="slash" *ngIf="rowData.form?.controls.CrossedOut.getRawValue()" style="margin-right: 0.5rem" matTooltip="gestrichen"></fa-icon>-->
<!--                <div *ngIf="rowData.isExpanded$ && rowData.isExpanded$ | async; else value" class="w-full pr-2 box-border">-->
<!--                    <app-arl-information-input-->
<!--                        [informationControl]="rowData.form.controls.Information"-->
<!--                        [ARLType]="rowData.form.controls.Type.value"-->
<!--                        [inputMode]="-->
<!--                                    rowData.form.controls.Type.value === ARLTypeEnum.ResourceArl || rowData.form.controls.Type.value === ARLTypeEnum.MaterialArl || rowData.form.controls.Type.value === ARLTypeEnum.EmployeeArl-->
<!--                                        ? 'selectSearch'-->
<!--                                        : 'autocomplete'-->
<!--                                "-->
<!--                        [entityId]="-->
<!--                                    rowData.form.controls.Type.value === ARLTypeEnum.ResourceArl-->
<!--                                        ? rowData.form.controls.ResourceId.value-->
<!--                                        : rowData.form.controls.Type.value === ARLTypeEnum.MaterialArl-->
<!--                                        ? rowData.form.controls.MaterialId.value-->
<!--                                        : rowData.form.controls.Type.value === ARLTypeEnum.EmployeeArl-->
<!--                                        ? rowData.form.controls.JobSpecificationId.value-->
<!--                                        : null-->
<!--                                "-->
<!--                        (entitySelected)="onSetEntityId(rowData, $event?.id, $event?.materialToSupplier)"-->
<!--                    ></app-arl-information-input>-->
<!--                </div>-->
<!--                <ng-template #value>-->
<!--                    &lt;!&ndash;                    {{ rowData.entity?.Information }}&ndash;&gt;-->
<!--                    {{ rowData.form?.controls.Information.getRawValue() }}-->
<!--                </ng-template>-->
<!--                <ng-container *ngIf="!determineIfIsArlTableDataOrGroupEnd(rowData)">-->
<!--                    <strong>Summe {{ rowData.information$ | async }}</strong>-->
<!--                </ng-container>-->
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CompleteCost">
            <mat-header-cell style="white-space: normal" *matHeaderCellDef class="{{ AutoColumnWithClass.CompleteCost }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'CompleteCost')"> {{ AutoColumnHeaders.CompleteCost }} </mat-header-cell>
            <mat-cell *matCellDef="let rowData" [style.overflow]="determineIfIsArlTableDataOrGroupEnd(rowData) ? '' : 'visible'" class="{{ AutoColumnWithClass.CompleteCost }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'CompleteCost')">
                <ng-container *ngIf="rowData.isExpanded$ && (rowData.isExpanded$ | async) && (rowData.isBookingPosition$ | async); else notExpanded">
                    {{ rowData.amount$ | async | currency: rowData.entity.CurrencyCode }}
                </ng-container>
                <ng-template #notExpanded>
                    <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData) && (rowData.isBookingPosition$ | async)">
                        <!--                        (id:{{rowData.entity.Id}})-->
                        <!--                        {{ (rowData.entity.CompleteCost - rowData.entity.CompleteTaxCost) | currency: rowData.entity.CurrencyCode }}-->
                        {{ rowData.amount$ | async | currency: rowData.entity.CurrencyCode }}
                    </ng-container>
                    <!--                    <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData) && !rowData.entity.isBookingPosition">-->
                    <!--                        (id:{{rowData.entity.Id}})-->
                    <!--                    </ng-container>-->
                    <ng-container *ngIf="!determineIfIsArlTableDataOrGroupEnd(rowData)">
                        <!--                        (id:{{rowData.groupId}})-->
                        {{ rowData.amount$ | async | currency }}
<!--                        <ng-container *ngIf="rowData.costAmountVM$ | async as vm"><br>({{ vm.costAmount | number: '1.2-2' }} + ZS: {{ vm.zs | percent: '1.0-2' }}) </ng-container>-->

                    </ng-container>
                </ng-template>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CompleteCostGross">
            <mat-header-cell style="white-space: normal" *matHeaderCellDef class="{{ AutoColumnWithClass.CompleteCostGross }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'CompleteCostGross')"> {{ AutoColumnHeaders.CompleteCostGross }} </mat-header-cell>
            <mat-cell *matCellDef="let rowData" [style.overflow]="determineIfIsArlTableDataOrGroupEnd(rowData) ? '' : 'visible'" class="{{ AutoColumnWithClass.CompleteCostGross }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'CompleteCostGross')">
                <ng-container *ngIf="rowData.isExpanded$ && (rowData.isExpanded$ | async) && (rowData.isBookingPosition$ | async); else notExpanded">
                    {{ rowData.amountWithTax$ | async | currency: rowData.entity.CurrencyCode }}
                </ng-container>
                <ng-template #notExpanded>
                    <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData) && (rowData.isBookingPosition$ | async)">
                        <!--                        (id:{{rowData.entity.Id}})-->
                        <!--                        {{ (rowData.entity.CompleteCost - rowData.entity.CompleteTaxCost) | currency: rowData.entity.CurrencyCode }}-->
                        {{ rowData.amountWithTax$ | async | currency: rowData.entity.CurrencyCode }}
                    </ng-container>
                    <!--                    <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData) && !rowData.entity.isBookingPosition">-->
                    <!--                        (id:{{rowData.entity.Id}})-->
                    <!--                    </ng-container>-->
                    <ng-container *ngIf="!determineIfIsArlTableDataOrGroupEnd(rowData)">
                        <!--                        (id:{{rowData.groupId}})-->
                        {{ rowData.amountWithTax$ | async | currency }}
                    </ng-container>
                </ng-template>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Position">
            <mat-header-cell *matHeaderCellDef class="{{ AutoColumnWithClass.Position }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'Position')">
                {{ AutoColumnHeaders.Position }}
            </mat-header-cell>
            <mat-cell *matCellDef="let rowData" class="{{ AutoColumnWithClass.Position }}" [class.hide]="!(DisplayedColumns$ | async | includes: 'Position')">
                <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData)">
                    <ng-container *ngIf="_itemNumbersLocked && rowData.isExpanded$ && (rowData.isExpanded$ | async); else positionValue">
                        <mat-form-field>
                            <mat-label>Pos.</mat-label>
                            <input
                                type="text"
                                matInput
                                class="position-input"
                                placeholder="Pos."
                                aria-label="Positionsnummer"
                                [formControl]="rowData.form.controls.ItemNumber" />
                        </mat-form-field>
                    </ng-container>

                    <ng-template #positionValue>
                        {{ rowData.form.controls.ItemNumber.value }}
                    </ng-template>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="DragButton">
            <mat-header-cell [class.small-fix]="!_multiselectActive" [class.medium-fix]="_multiselectActive" *matHeaderCellDef>
                <mat-checkbox *ngIf="_multiselectActive && mainCheckboxData$ | async as mainCheckboxData" (change)="multiselectSelectAll($event.checked)" [checked]="mainCheckboxData.allSelected" [indeterminate]="mainCheckboxData.indeterminate" class="px-2"></mat-checkbox>
                <fa-icon icon="arrows-alt-v" style="margin: 0 1rem"></fa-icon>
            </mat-header-cell>
            <mat-cell [class.small-fix]="!_multiselectActive" [class.medium-fix]="_multiselectActive" *matCellDef="let rowData">
                <div (click)=" $event.stopPropagation()" *ngIf="_multiselectActive" class="px-2">
                    <mat-checkbox *ngIf="determineIfIsArlTableDataOrGroupEnd(rowData)" [checked]="selection.isSelected(rowData.entity.Id)" (change)="multiselectSelect($event.checked, rowData)"></mat-checkbox>
                    <mat-checkbox *ngIf="!determineIfIsArlTableDataOrGroupEnd(rowData)" [checked]="selection.isSelected(rowData.groupId)" [disabled]="true"></mat-checkbox>
                </div>
                <button
                    class="drag-button"
                    cdkDragHandle
                    (mousedown)="isInvalidDragEvent = false"
                    [disabled]="_disabled || _itemNumbersLocked"
                    [class.is-loading]="ls.IsLoading$ | async"
                    mat-icon-button
                    (click)="$event.stopPropagation(); onMoveClick(rowData);"
                >
                    <fa-icon [icon]="getArlTypeIcon(rowData?.form?.controls?.Type?.value)" style="margin-right: 0.5rem"></fa-icon>
                    <fa-icon icon="bars"></fa-icon>
                </button>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="IsVisible">
            <mat-header-cell class="{{ AutoColumnWithClass.IsVisible }} jsut-center" *matHeaderCellDef></mat-header-cell>
            <mat-cell style="align-self: flex-start" class="{{ AutoColumnWithClass.IsVisible }} jsut-center" *matCellDef="let element" [attr.colspan]="determineIfIsArlTableDataOrGroupEnd(element) ? 1 : 0">
                <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(element) && (element.isBookingPosition$ | async)">
                    <button
                        mat-icon-button
                        (click)="element.form.controls.childrenVisible.setValue(!element.form.value.childrenVisible); element.form.controls.childrenVisible.markAsDirty()"
                        *ngIf="element.isExpanded$ | async; else icon"
                        [matTooltip]="'unterpositionen ' + (element.form.value.childrenVisible ? 'ausblenden' : 'einblenden')"
                        [disabled]="element.form.controls.childrenVisible.disabled || _disabled"
                    >
                        <fa-icon [icon]="element.form.value.childrenVisible ? 'eye' : 'eye-slash'"></fa-icon>
                    </button>
                    <ng-template #icon>
                        <fa-icon *ngIf="element.form.controls.childrenVisible.enabled && !element.form.value.childrenVisible" [icon]="element.form.value.childrenVisible ? 'eye' : 'eye-slash'"></fa-icon>
                    </ng-template>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="InheritFromChildren">
            <mat-header-cell class="{{ AutoColumnWithClass.InheritFromChildren }} jsut-center" *matHeaderCellDef></mat-header-cell>
            <mat-cell class="{{ AutoColumnWithClass.InheritFromChildren }} jsut-center" style="align-self: flex-start" *matCellDef="let element" [attr.colspan]="determineIfIsArlTableDataOrGroupEnd(element) ? 1 : 0">
                <ng-container *ngIf="determineIfIsArlTableDataOrGroupEnd(element) && (element.isBookingPosition$ | async)">
                    <span class="inherit-from-children-button" *ngIf="element.form.value.InheritFromChildren">
                        <strong>K</strong>
                    </span>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="EditButton">
            <mat-header-cell class="{{ AutoColumnWithClass.EditButton }}" *matHeaderCellDef></mat-header-cell>
            <mat-cell class="{{ AutoColumnWithClass.EditButton }}" *matCellDef="let element">
                <app-arl-table-cell-edit-button
                    [rowData]="element"
                    [_disabled]="_disabled"
                    [disableMove]="_itemNumbersLocked"
                    [syncCostAmountAndBaseCost]="syncCostAmountAndBaseCost"
                    (onCollapseRowClick)="expandRow(null)"
                    (onAllowanceClick)="onAllowanceClick(element)"
                    (onChargeClick)="onChargeClick(element)"
                    (onChargeOverrideClick)="onChargeOverrideClick(element)"
                    (onToggleOptional)="onToggleOptional(element)"
                    (onToggleCrossedOut)="onToggleCrossedOut(element)"
                    (onCopyClick)="onCopyClick(element)"
                    (onMoveClick)="onMoveClick(element)"
                    (onToggleStartOnNewPage)="onToggleStartOnNewPage(element)"
                    (onDeleteClick)="onDeleteClick(element)"
                    (onToggleFixedPrice)="onToggleFixedPrice(element)"
                    (onSplitClick)="splitPositions([element.entity.Id])"
                ></app-arl-table-cell-edit-button>
            </mat-cell>
        </ng-container>
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let element" [attr.colspan]="allColumns$ | async | length" class="flex-col p-0">
                <!--                <div class="element-detail" [@detailExpand]="element.animationTrigger$ | async">-->
                <ng-container *ngIf="element.isExpanded$">
                    <div class="long-text-wrapper" *ngIf="element.isExpanded$ | async">
                        <mat-checkbox [formControl]="element.form.controls.ShowLongtext" matTooltip="Langtext anzeigen"></mat-checkbox>
                        <mat-form-field>
                            <mat-label>Langtext</mat-label>
                            <div #wrapperLangText class="textarea-with-template-button">
                                <textarea matInput cdkTextareaAutosize [cdkAutosizeMinRows]="3" [formControl]="element.form.controls.Longtext"></textarea>
                                <button class="template-button" app-round-button
                                        (mousedown)="$event.preventDefault()"
                                        (click)="insertTemplate(element.form.controls.Longtext, wrapperLangText.querySelector('textarea'))"
                                        matTooltip="Vorlage einfügen">
                                    <fa-icon icon="file-lines"></fa-icon>
                                </button>
                            </div>
                        </mat-form-field>
                    </div>
                    <div class="element-detail inset-top-shadow mx-6" [class.collapsed]="!(element.isExpanded$ | async)" *ngIf="!(element.isBookingPosition$ | async)">
                        <!--                    {{ element.form?.value.name }}-->
                        <!--                    <mat-form-field *ngIf="element.form?.controls.name">-->
                        <!--                        <mat-label>Name</mat-label>-->
                        <!--                        <input matInput type="text" [formControl]="element.form.controls.name">-->
                        <!--                    </mat-form-field>-->

                        <div class="action-row">
                            <button app-button Color="cancel" [IsLoading]="ls.IsLoading$ | async" [Disabled]="!element.form?.dirty" Inverted (click)="onAbortGroupClick(element)">abbrechen</button>
                            <span class="spacer"></span>
                            <!--                                    <button app-button Color="red" [disabled]="_disabled" [IsLoading]="ls.IsLoading$ | async" (click)="onDeleteClick(element)">löschen</button>-->
                            <!--                            <span class="spacer"></span>-->
                            <!--                        <button app-button Color="green" [IsLoading]="ls.IsLoading$ | async" [Disabled]="someFormDirty$ | async" (click)="onDuplicateClick()">duplizieren</button>-->
                            <!--                            <button app-button Color="green" [IsLoading]="ls.IsLoading$ | async" [Disabled]="!element.form?.dirty || element.form?.invalid" (click)="onSaveGroupClick(element)">speichern</button>-->
                        </div>
                    </div>
                    <div class="element-detail inset-top-shadow mx-6" [class.collapsed]="!(element.isExpanded$ | async)" *ngIf="element.isBookingPosition$ | async">
                        <!--                        {{ element.entity?.Id }}-->
                        <app-arl-table-detail-row
                            style="width: 100%"
                            [quantityHistoryForm]="element.form"
                            (AbortClick)="onAbortClick(element)"
                            [disabled]="_disabled"
                            [FilterMaterialsByCustomerId]="FilterMaterialsByCustomerId"
                            [forceQuantityTypeIdForEmployeeArls]="forceQuantityTypeIdForEmployeeArls"
                            [arlTableCalculationPositionHelper]="element.arlTableCalculationPositionHelper"
                        ></app-arl-table-detail-row>

<!--                        <app-arl-table-detail-row-->
<!--                            style="width: 100%"-->
<!--                            [position]="element.position$ | async"-->
<!--                            [arl]="element.entity"-->
<!--                            [quantityHistoryForm]="element.form"-->
<!--                            (AbortClick)="onAbortClick(element)"-->
<!--                            [ArlFormDirty]="element.form.dirty"-->
<!--                            [ArlFormInvalid]="element.form.invalid"-->
<!--                            [inheritFromChildrenForm]="element.form.controls.InheritFromChildren"-->
<!--                            [childrenVisibleForm]="element.form.controls.childrenVisible"-->
<!--                            [ARLCalculationPreChargeByTypes]="ARLCalculationPreChargeByTypes"-->
<!--                            [aRLCalculationPreCharge]="aRLCalculationPreCharge"-->
<!--                            [ZuschlaegeResourcen]="element.form.controls.ZuschlaegeResourcen.getRawValue()"-->
<!--                            [ZuschlaegeMaterials]="element.form.controls.ZuschlaegeMaterials.getRawValue()"-->
<!--                            [ZuschlaegeDefault]="element.form.controls.ZuschlaegeDefault.getRawValue()"-->
<!--                            [ZuschlaegeEmployee]="element.form.controls.ZuschlaegeEmployee.getRawValue()"-->
<!--                            [ZuschlaegeExternalService]="element.form.controls.ZuschlaegeExternalService.getRawValue()"-->
<!--                            [ZuschlaegeOther]="element.form.controls.ZuschlaegeOther.getRawValue()"-->
<!--                            [disabled]="_disabled"-->
<!--                            [FilterMaterialsByCustomerId]="FilterMaterialsByCustomerId"-->
<!--                            [liDocumentType]="liDocumentType"-->
<!--                            [forceQuantityTypeIdForEmployeeArls]="forceQuantityTypeIdForEmployeeArls"-->
<!--                            [ARLSurChargeByTypes]="ARLSurChargeByTypes"-->
<!--                            [arlTableCalculationPositionHelper]="element.arlTableCalculationPositionHelper"-->
<!--                        ></app-arl-table-detail-row>-->
                    </div>
                </ng-container>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="group">
            <mat-cell *matCellDef="let element" [attr.colspan]="allColumns$ | async | length">
                <strong>{{ element.group?.name }}</strong>
            </mat-cell>
        </ng-container>
        <mat-header-row  [class.hide]="!(tableData$ | async)?.length" *matHeaderRowDef="allColumns$ | async; sticky: !(expandedElement$ | async)"></mat-header-row>
<!--      dummy row for can drop at position, without drop at index 0 is everytime possible-->
       <mat-row style="display: none" cdkDrag cdkDragDisabled></mat-row>
        <mat-row
            [cdkDragDisabled]="row.isExpanded$ && row.isExpanded$ | async"
            cdkDrag
            (cdkDragStarted)="dragStarted($event)"
            (click)="expandRow(row)"
            [cdkDragData]="row"
            cdkDragPreviewContainer="parent"
            class="element-row"
            [class.expanded-row]="row.isExpanded$ && row.isExpanded$ | async"
            [class.is-booking-position]="row.isBookingPosition$ | async"
            *matRowDef="let row; columns: allColumns$ | async"
        ></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row id-{{ row.entity?.Id }}"></mat-row>
        <tr class="mat-row empty-row" style="display: flex" *matNoDataRow>
            <td class="mat-cell" style="flex-grow: 1; display: flex; align-items: center" [attr.colspan]="(allColumns$ | async)?.length">
                <span>Keine Abrechnungspositionen vorhanden</span>
            </td>
        </tr>
    </mat-table>
<app-mat-paginator-wrapper>
    <mat-paginator [pageSize]="100" [pageSizeOptions]="[25, 50, 100, 250]" aria-label="Seite auswählen" [length]="length$ | async"></mat-paginator>
</app-mat-paginator-wrapper>
